import React from 'react';
import ToolTip from 'components/Tooltip';

interface Props {
  active: boolean,
  cost?: number,
  parent: any,
}

export default function ActionCostTooltip({ active, cost, parent }: Props) {
  if (cost === undefined || cost === 1) {
    return null;
  }
  const data = {
    image: 'actions',
    secondaryDescription: `This will cost you ${cost > 0 ? cost : 'no '} actions`,
  };
  return <ToolTip active={active} data={data} parent={parent} />;
}

ActionCostTooltip.displayName = 'ActionCostTooltip';
